import { postRequest } from '../../../helpers/request';

export default {
  namespaced: true,

  state: () => ({
    dashboard: null,
    loading: false,
    error: null,
  }),

  mutations: {
    setDashboard(state, data) {
      state.dashboard = data;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setError(state, err) {
      state.error = err;
    },
  },

  actions: {
    async fetchDashboard({ commit }, { cropYearId, unitId } = {}) {
      commit('setLoading', true);
      commit('setError', null);
      try {
        const params = { crop_year_id: cropYearId };
        if (unitId) params.unit_id = unitId;
        const data = await postRequest('/farm_profile/api/hedgeflow/dashboard/', params);
        commit('setDashboard', data);
      } catch (err) {
        commit('setError', err?.message || 'Failed to load HedgeFlow data.');
        commit('setDashboard', null);
      } finally {
        commit('setLoading', false);
      }
    },
  },
};
